import styled, { css } from 'styled-components';
import { layout } from '../../../../package.json';

export const Container = styled.div`
  width: 100%;

  border: 1px solid var(--primary);
  padding: 2rem;
  border-radius: 8px;
`;

export const ContainerTitle = styled.div`
  margin-left: 15px;
  span {
    top: 10px;
    color: #999999;
    font-size: 14px;
    font-weight: 800;
  }
`;

interface ContainerButtonProps {
  bgColor?: string;
  fgColor?: string;
}

export const ContainerButton = styled.div<ContainerButtonProps>`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 130px;
  height: 50px;
  border-radius: 5px;
  border: 1px solid var(--primary);
  margin-bottom: 10px;
  cursor: pointer;

  span{
    text-align: center;
  }

  transition:all 0.6s ease;

  ${props => props.bgColor && css`
    background-color:${props.bgColor};
  `}

  ${props => props.fgColor && css`
    color:${props.fgColor};
  `}

  :hover{
    background-color: var(--primary);

    span {
      color: #FFF;
    }
  }
`;

export const ContainerAddressRowHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;

  width: 100%;
  border-radius: 8px;
  margin-bottom: 15px;

  h3 {
    margin-bottom: 8px;
  }
`;

export const ContainerPayments = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: ${layout.tablet}) {
    flex-direction: column;
  }
`;

interface ContainerPaymentProps {
  full: boolean;
}

export const ContainerPayment = styled.div<ContainerPaymentProps>`
  display: flex;
  justify-content: flex-start;
  margin-top: 15px;
  width: 65%;

  border-radius: 8px;
  border: 1px solid var(--primary);
`;

export const ContainerPaymentItem = styled.div`
  grid-gap: 16px;
  width: 100%;
`;

export const ContainerPaymentButtoms = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  margin-top: 10px;
`;

export const ContainerPaymentMethods = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 16px;
  width: 50%;
`;

export const ItemPayment = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 150px;
  height: 40px;

  cursor: pointer;

  border: 1px solid var(--primary);
  padding: 10px;
  border-radius: 20px;
  margin-right: 10px;
  transition:all 0.6s ease;

  text-align: center;
  span {
      color: var(--primary);
      font-size: 14px;
    }

  :hover{
    background-color: var(--primary);

    span {
      color: #FFF;
      font-size: 14px;
    }
  }
`;

export const ContainerPaymentRight = styled.div`
  /* border: 1px solid; */
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 310px;

  @media (max-width: ${layout.tablet}) {
    max-width: 100%;
    flex-direction: column;
  }
`;

export const ContainerPaymentData = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: row;

  margin-top: 15px;

  width:  100%;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid var(--primary);
`;

export const ContainerDataRequest = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;

  width: 100%;

  padding: 5px;
  border-radius: 8px;

`;

export const ContainerDataRequestItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;

  width: 100%;
  padding: 10px;
  font-weight: 500;
`;

export const ContainerNew = styled.div`
  width: 100%;
`;


export const ContainerDefaultPayCard = styled.div`
  width: 100%;
  padding: 10px;
  border-radius: 8px;

  border: 1px solid var(--primary);
  background-color: #672d903b;
`;


export const CardBrand = styled.div`
  margin-right: 10px;
`;

export const CardNumber = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;

  margin-right: 10px;
  span {
    margin-left: 10px;
  }
`;

export const CardName = styled.div`
  margin-right: 10px;
`;

export const CardContainerSplit = styled.div``;

export const ContainerPaymentLeft = styled.div`
  margin: 15px;
  border-radius: 8px;
  flex:1;
`;

export const ContainerMap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 31rem;  
`

export const DivSpace = styled.div`
  overflow: hidden;
  padding-top: calc(100% * 0.6);
  width: 100%;
  position: relative;

  > div {
    position: absolute !important;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 0 auto;
  }
`

export const ResumeContainer = styled.section`
  width: 100%;
  max-width: 760px;
  h3 {
  margin-bottom: 20px;
  }
`;

export const ContainerProducts = styled.div`
  width: 100%;
  max-height: 550px;
  overflow-y: auto;
`
